import React from 'react';
import '../styles/HomePage.css';  // Import the CSS for styling


const HomePage = () => {
  return (
    <div className="homepage-container">
      <h1>CS 10 Mans</h1>
    </div>
  );
};

export default HomePage;
